import { createFileRoute } from "@tanstack/react-router";
import { seoHead } from "@/config/seoHead";
import { canonicalMunicipalitySlug, permanentRedirect } from "@/lib/legacyRedirects";


/** Gamla kommun-URL:er – permanent omdirigering till elprissidan. */
export const Route = createFileRoute("/kommun/$slug")({
  head: () => seoHead("/kommun/$slug"),
  beforeLoad: ({ params }) =>
    permanentRedirect(`/elpriser/${canonicalMunicipalitySlug(params.slug ?? "")}`),
});
